import cx from 'classnames'
import Icon from 'components/Icon'
import { VideoCallStatus } from 'messaging/calling/VideoCall'
import CallViewModel, {
  CallOperatorState,
} from 'messaging/calling/CallViewModel'
import { observer } from 'mobx-react'
import * as React from 'react'
import { formatDuration } from 'utils/date-util'
import * as Duration from 'dration'
import styles from './CallStatusInfo.sass'

const timeFormatter = new Intl.DateTimeFormat('en-US', {
  hour12: true,
  hour: 'numeric',
  minute: 'numeric',
})

interface CallStatusInfoProps {
  vm: CallViewModel
}

/**
 " Call Status Info
 */
export const CallStatusInfo = observer(function CallStatusInfo({
  vm,
}: CallStatusInfoProps) {
  let icon: React.ReactNode
  let title: string
  let subtitle: string
  let ended = false
  const otherParticipants = vm.call.otherParticipants
  const durationText = formatDuration(vm.duration, 'long', 'a few seconds')
  switch (vm.call.callStatus) {
    case VideoCallStatus.InProgress: {
      icon = <Icon name="phone" />
      if (vm.state === CallOperatorState.Connected) {
        title = 'Call Started'
        subtitle = `${Duration.format(vm.duration)}`
        break
      }
      title =
        vm.state === CallOperatorState.Incoming &&
        otherParticipants.length === 1
          ? `${otherParticipants[0].member.displayName} is calling you...`
          : 'Call Started'
      subtitle = `Started ${durationText} ago`
      break
    }
    case VideoCallStatus.Completed: {
      icon = <Icon name="call-end-call" />
      title = 'Call Ended'
      subtitle = `Ended at ${timeFormatter.format(
        vm.call.dateCompleted ?? undefined
      )} — Lasted ${durationText}`
      ended = true
      break
    }
    case VideoCallStatus.Unknown: {
      icon = <Icon name="info" />
      title = 'Unknown Call Status'
      subtitle = `This is a bit odd.`
      break
    }
  }

  return (
    <div className={styles.root}>
      <div className={styles.iconContainer}>
        <div className={cx(styles.iconBox, ended && styles.ended)}>{icon}</div>
      </div>
      <div className={styles.text}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
    </div>
  )
})
